import { businessColaboratorCreateDto, businessColaboratorDto } from '@/entities/businessColaborator';
import { Api } from './api/axios-config';

export class BusinessColaboratorService {
    private static api = Api();

    public static async getColaboratorByBusiness(businessId: number) {
        const response = await this.api.get<any>(`Bcollab/${businessId}`);
        if (response.status === 200) {
            return response.data;
        }
    }

    public static async deleteColaboratorBusiness(id: number, businessId: number) {
        const response = await this.api.delete<any>(`delete/${id}/${businessId}`);
        return response;
    }

    public static async createColaboratorBusiness(businessColaborator: businessColaboratorCreateDto) {
        try {
            const response = await this.api.post(`/Bcollab`, {
                collaboratorId: businessColaborator.collaboratorId,
                isAdmin: businessColaborator.isAdmin,
                businessId: businessColaborator.businessId
            });
            return response;
        } catch (error) {
            console.error('Erro ao carregar o preview:', error);
        }
    }

}
